export function initializeDataTables() {
    let $datatables = $('main table.datatables');

    if ( $datatables.length ){
        $datatables.DataTable();
    }
}
